import * as React from "react";
const SvgFiRrPriorityImportance = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-priority-importance_svg__a)">
      <path
        fill="#062147"
        d="M8 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m15.749 6.662-2.981-2.981c-.942-.943-2.589-.944-3.535 0L14.294 9.62a.999.999 0 1 0 1.414 1.414l2.293-2.293v14.207a1 1 0 1 0 2 0V8.741l2.335 2.335a.997.997 0 0 0 1.414 0 1 1 0 0 0-.001-1.414M9 13h3a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2M6 2.5v1.004c0 1.378-1.121 2.5-2.5 2.5h-1a2.503 2.503 0 0 1-2.5-2.5V2.5C0 1.121 1.121 0 2.5 0h1C4.879 0 6 1.121 6 2.5m-2 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.004a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5zm2 9v1.004c0 1.378-1.121 2.5-2.5 2.5h-1a2.503 2.503 0 0 1-2.5-2.5V11.5C0 10.122 1.121 9 2.5 9h1C4.879 9 6 10.122 6 11.5m-2 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.004a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5zM14 20H9a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2m-8 .5v1.004c0 1.378-1.121 2.5-2.5 2.5h-1a2.503 2.503 0 0 1-2.5-2.5V20.5C0 19.122 1.121 18 2.5 18h1C4.879 18 6 19.122 6 20.5m-2 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.004a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-priority-importance_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPriorityImportance;
